const reportPalettes = {
    digital: 'digital',
    annual: 'annual',
};

export default reportPalettes;
